import withPrivateRoute from '@/components/hoc/withPrivateRoute';
import { ROLES_PERMISSIONS } from '@/constants';
import { QueryParamsProvider } from '@/contexts/query-params/QueryParamsProvider';
import ProjectsPage from './ProjectsPage';

const DEFAULT_PARAMS = { offset: 1, limit: 10 };

function PrivateProjects() {
  return (
    <QueryParamsProvider defaultParams={DEFAULT_PARAMS}>
      <ProjectsPage />
    </QueryParamsProvider>
  );
}

const Projects = withPrivateRoute(
  PrivateProjects,
  ROLES_PERMISSIONS.TIME_TRACKING.VIEW
);

export default Projects;
